import { TListingCompilationSettings } from '../../../types/blackFriday';
import { IListingCompilation } from '../../../types/promosPage';

export function getImageUrl(item: IListingCompilation, listingCompilationSettings: TListingCompilationSettings) {
  return listingCompilationSettings[item.type]?.imageUrl ?? '';
}
